export default {
  blockEntries: {},
  blockError: null,
};
